import { Component, Inject } from '@angular/core';
import {
  MAT_DIALOG_DATA,
  MatDialogModule,
  MatDialogRef,
} from '@angular/material/dialog';
import { HttpService } from '../../services/http/http.service';
import { MatSnackBar } from '@angular/material/snack-bar';
import { MatIconModule } from '@angular/material/icon';
import { MatButtonModule } from '@angular/material/button';
import { tap, switchMap, catchError } from 'rxjs/operators';
import { EMPTY} from 'rxjs';

enum RifiutaStep {
  COMPETENZA = 1,
  ASSOCIAZIONI = 2,
}

@Component({
  selector: 'app-rifiuta-competenza',
  templateUrl: './rifiuta-competenza.component.html',
  styleUrls: ['./rifiuta-competenza.component.scss'],
  imports: [MatDialogModule, MatIconModule, MatButtonModule],
  standalone: true,
})
export class RifiutaCompetenzaComponent {
  constructor(
    public dialogRef: MatDialogRef<RifiutaCompetenzaComponent>,
    @Inject(MAT_DIALOG_DATA)
    public data: { idCompetenza: number;},
    public api: HttpService,
    public snackBar: MatSnackBar,
  ) {}

  step: RifiutaStep = RifiutaStep.COMPETENZA;
  get title(): string {
    return this.step === RifiutaStep.COMPETENZA
      ? 'Rifiuta competenza'
      : 'Rifiuta Abilità e Conoscenze';
  }

  get message(): string {
    return this.step === RifiutaStep.COMPETENZA
      ? 'Sei sicuro di voler rifiutare la proposta di competenza?'
      : 'Si deve procedere al rifiuto anche delle relative Abilità e Conoscenze?';
  }

  handleClick(): void {
    this.step === RifiutaStep.COMPETENZA
      ? this.handleCompetenzaStep()
      : this.handleAbilitaConoscenzeStep();
  }

  private handleCompetenzaStep(): void {
    this.api
      .checkAbilitaConoscenze({ valore: this.data.idCompetenza })
      .pipe(
        switchMap((res: any) => {
          if (!res.result.booleano) {
            return this.rifiutaCompetenza$().pipe(
              tap(() => {
                this.snackBar.open('Competenza rifiutata correttamente', 'close', {
                  panelClass: 'successSnack',
                });
                this.dialogRef.close(true);
              }),
            );
          } else {
            this.step = RifiutaStep.ASSOCIAZIONI;
            return EMPTY;
          }
        }),
        catchError((error) => {
          console.error('Errore controllo associazioni:', error);
          this.snackBar.open(
            'Errore durante il controllo delle abilità e conoscenze',
            'close',
            {
              panelClass: 'errorSnack',
            },
          );
          return EMPTY;
        }),
      )
      .subscribe();
  }

  private handleAbilitaConoscenzeStep(): void {
    this.api
      .rifiutaCompetenzaCascade(this.data.idCompetenza)
      .pipe(
        tap((res: any) => {
          if (res.operation != 3) {
            let message = res.result.message;
            this.snackBar.open(
              message,
              'close',
              { panelClass: ['multi-line-snackbar', 'successSnack'] },
            );
            this.dialogRef.close(true);
          }
        }),
        catchError((error) => {
          console.error('Errore rifiuto abilità e conoscenze:', error);
          this.snackBar.open(
            "Errore durante il rifiuto delle abilità e conoscenze",
            'close',
            { panelClass: 'errorSnack' },
          );
          return EMPTY;
        }),
      )
      .subscribe();
  }

  private rifiutaCompetenza$() {
    return this.api.rifiutaCompetenza(this.data.idCompetenza);
  }

  private rifiutaCompetenzaDiretta(): void {
    this.rifiutaCompetenza$()
      .pipe(
        tap(() => {
          this.snackBar.open('Competenza rifiutata correttamente', 'close', {
            panelClass: 'successSnack',
          });
          this.dialogRef.close(true);
        }),
        catchError((error) => {
          console.error('Errore rifiuto competenza:', error);
          this.snackBar.open(
            "Errore durante il rifiuto della competenza",
            'close',
            {
              panelClass: 'errorSnack',
            },
          );
          return EMPTY;
        }),
      )
      .subscribe();
  }

  closeDialog(refresh: boolean, deletedCascade: boolean = false): void {
    if (this.step === RifiutaStep.ASSOCIAZIONI && !deletedCascade) {
      this.snackBar.open(
        'Le abilità e conoscenze non rifiutate resteranno associate alle relative competenze ancora esistenti',
        'close',
        { panelClass: 'successSnack' },
      );
    }
    this.dialogRef.close(refresh || this.step === RifiutaStep.ASSOCIAZIONI);
  }

  onNoClick(): void {
    if (this.step === RifiutaStep.COMPETENZA) {
      this.closeDialog(false);
    } else {
      this.rifiutaCompetenzaDiretta();
    }
  }
}
